(function () {
	const mobileQuery = window.matchMedia("(max-width: 575px)");
	const STORAGE_KEY = "per-row-preference";

	// Highlight the button that matches what's actually shown: mobile columns
	// follow data-mobile-per-row (the columns_mobile default), desktop follows
	// data-productis-in-row (the default_per_row default).
	const syncActive = () => {
		const container = document.querySelector("[data-productis-in-row]");
		if (!container) return;
		const current = mobileQuery.matches
			? container.getAttribute("data-mobile-per-row")
			: container.getAttribute("data-productis-in-row");
		$(".per-row__button").removeClass("active");
		$(`.per-row__button[data-per-row="${current}"]`).addClass("active");
	};

	// Pagination and new page loads re-render the grid from the section's
	// default settings, which would otherwise drop a shopper's layout choice.
	// Re-apply anything saved in localStorage before the buttons are synced.
	const applyStoredPreference = () => {
		let value;
		try {
			value = localStorage.getItem(STORAGE_KEY);
		} catch (e) {
			return;
		}
		if (!value) return;
		const container = document.querySelector("[data-productis-in-row]");
		if (!container) return;
		container.setAttribute("data-productis-in-row", value);
		container.setAttribute("data-mobile-per-row", value);
	};

	const productsPerRow = () => {
		applyStoredPreference();

		$(".per-row__button").click(function () {
			const value = $(this).data("per-row");
			$(".per-row__button").removeClass("active");
			$(`.per-row__button[data-per-row="${value}"]`).addClass("active");
			$("[data-productis-in-row]").attr("data-productis-in-row", value);
			$("[data-productis-in-row]").attr("data-mobile-per-row", value);
			try {
				localStorage.setItem(STORAGE_KEY, value);
			} catch (e) {}
		});

		syncActive();
	};

	mobileQuery.addEventListener("change", syncActive);

	document.addEventListener("shopify:section:load", function () {
		productsPerRow();
	});
	productsPerRow();
})();
